import script from "./CompareProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompareProduct.vue?vue&type=script&lang=ts&setup=true"

import "./CompareProduct.vue?vue&type=style&index=0&id=058ac264&lang=css"

const __exports__ = script;

export default __exports__